import React from 'react'
import SimplePage from '../layouts/simplePage'

const RoadRoutes = () => {
    return (
        <SimplePage
            image={require('../assets/images/142302.jpg')}
            title={'IMPORTANT ROAD ROUTES'}
        >
            <div className='table-responsive'>
                <table className='table table-striped'>
                    <tbody>
                        <tr>
                            <td>
                                <b>KOLKATA TO DELHI (1411.6 KMS)</b>
                            </td>
                            <td>
                                <b>&nbsp; Kms.</b>
                            </td>
                        </tr>
                        <tr>
                            <td>Kolkata - Durgapur - Asansol</td>
                            <td>&nbsp; 222.0</td>
                        </tr>
                        <tr>
                            <td>Asansol - Gobindpur - Barhi - Dhobi</td>
                            <td>&nbsp; 233.0</td>
                        </tr>
                        <tr>
                            <td>Dhobi - Sasaram</td>
                            <td>&nbsp; 105.0</td>
                        </tr>
                        <tr>
                            <td>Sasaran - Moghulsarai - Banaras - Allahabad</td>
                            <td>&nbsp; 240.0</td>
                        </tr>
                        <tr>
                            <td>Allahabad - Kanpur</td>
                            <td>&nbsp; 195.6</td>
                        </tr>
                        <tr>
                            <td>Knapur - Etah</td>
                            <td>&nbsp; 218.4</td>
                        </tr>
                        <tr>
                            <td>Etah - Aligarh - Delhi</td>
                            <td>&nbsp; 197.6</td>
                        </tr>
                        <tr height='25'>
                            <td colspan='2'>
                                <b>
                                    KOLKATA TO MUMBAI via NAGPUR (2131.8 Kms){' '}
                                </b>
                                &nbsp;
                            </td>
                        </tr>
                        <tr>
                            <td>Howrah Station - Lodhasuli - Bharagora</td>
                            <td>&nbsp; 183.6</td>
                        </tr>
                        <tr>
                            <td>Bharagora - Chowdhar</td>
                            <td>&nbsp; 260.0</td>
                        </tr>
                        <tr>
                            <td>Chowdhar - Angul - Sambalpur - Attabira</td>
                            <td>&nbsp; 302.0</td>
                        </tr>
                        <tr>
                            <td>Attabira - Bargarh - Saraupalli - Rajpur</td>
                            <td>&nbsp; 244.0</td>
                        </tr>
                        <tr>
                            <td>Rajpur - Durg - Khomara</td>
                            <td>&nbsp; 164.2</td>
                        </tr>
                        <tr>
                            <td>Khomara - Bhandara - Nagpur</td>
                            <td>&nbsp; 116.0</td>
                        </tr>
                        <tr>
                            <td>Nagpur - Amaraoti</td>
                            <td>&nbsp; 155.2</td>
                        </tr>
                        <tr>
                            <td>Amaraoti - akola - Khamgoraon - Nandura</td>
                            <td>&nbsp; 164.2</td>
                        </tr>
                        <tr>
                            <td>Nandura - Jalgaon</td>
                            <td>&nbsp; 114.0</td>
                        </tr>
                        <tr>
                            <td>Jalgaon - Erandol - Dhulia</td>
                            <td>&nbsp;&nbsp;&nbsp; 88.8</td>
                        </tr>
                        <tr>
                            <td>Dhulia - Malegaon - Chandor</td>
                            <td>&nbsp;&nbsp;&nbsp; 92.0</td>
                        </tr>
                        <tr>
                            <td>Chandor - Nasik</td>
                            <td>&nbsp;&nbsp;&nbsp; 64.0</td>
                        </tr>
                        <tr>
                            <td>Nasik - Ghoti - Shahpur - Bhiwandi</td>
                            <td>&nbsp; 192.0</td>
                        </tr>
                        <tr>
                            <td>Bhiwandi - Mumbai</td>
                            <td>&nbsp;&nbsp;&nbsp; 55.6</td>
                        </tr>
                        <tr>
                            <td colspan='2'>
                                <b>KOLKATA TO CHENNAI (1700 Kms.) &nbsp;</b>
                            </td>
                        </tr>
                        <tr>
                            <td>Howrah Station - Lodhasuli - Baharagora</td>
                            <td>&nbsp; 183.6</td>
                        </tr>
                        <tr>
                            <td>Baharagora - Cuttack</td>
                            <td>&nbsp; 274.0</td>
                        </tr>
                        <tr>
                            <td>Cuttack - Ichhapuram</td>
                            <td>&nbsp; 212.2</td>
                        </tr>
                        <tr>
                            <td>Ichhapuram - Srikakualam</td>
                            <td>&nbsp; 128.4</td>
                        </tr>
                        <tr>
                            <td>Srikakaulam - Visakhapatnam - Anakapalle</td>
                            <td>&nbsp; 133.0</td>
                        </tr>
                        <tr>
                            <td>Anakapalle - Rajanagram - Rajahmundry</td>
                            <td>&nbsp; 168.6</td>
                        </tr>
                        <tr>
                            <td>Rajahmundry - Kodur - Ellura - Vijayawada</td>
                            <td>&nbsp; 169.8</td>
                        </tr>
                        <tr>
                            <td>Vijayawada - Ongole - Nellore</td>
                            <td>&nbsp; 257.6</td>
                        </tr>
                        <tr>
                            <td>Nellore - Chennai</td>
                            <td>&nbsp; 172.8</td>
                        </tr>
                        <tr>
                            <td colspan='2'>
                                <b>DELHI TO MUMBAI VIA INDORE (1413.6 Kms)</b>
                                &nbsp;
                            </td>
                        </tr>
                        <tr>
                            <td>Delhi - Agra</td>
                            <td>&nbsp; 210.1</td>
                        </tr>
                        <tr>
                            <td>Agra - Gwalior</td>
                            <td>&nbsp; 116.8</td>
                        </tr>
                        <tr>
                            <td>Gwalior - Shivpuri</td>
                            <td>&nbsp; 193.6</td>
                        </tr>
                        <tr>
                            <td>Shivpuri - Goona - Bioara</td>
                            <td>&nbsp; 194.4</td>
                        </tr>
                        <tr>
                            <td>Bioara - Indore</td>
                            <td>&nbsp; 108.0</td>
                        </tr>
                        <tr>
                            <td>Indore - Dhamnod</td>
                            <td>&nbsp;&nbsp;&nbsp; 76.0</td>
                        </tr>
                        <tr>
                            <td>Dhamnod - Julwania - Sendhwa</td>
                            <td>&nbsp;&nbsp;&nbsp; 74.4</td>
                        </tr>
                        <tr>
                            <td>Sendhwa - Dhulia</td>
                            <td>&nbsp; 108.6</td>
                        </tr>
                        <tr>
                            <td>Dhulia - Maligaon - Chandor</td>
                            <td>&nbsp;&nbsp;&nbsp; 92.0</td>
                        </tr>
                        <tr>
                            <td>Chandor - Nasik</td>
                            <td>&nbsp;&nbsp;&nbsp; 64.0</td>
                        </tr>
                        <tr>
                            <td>Nasik - Ghori - Shahpur - Bhiwandi</td>
                            <td>&nbsp; 128.0</td>
                        </tr>
                        <tr>
                            <td>Bhiwandi - Mumbai</td>
                            <td>&nbsp;&nbsp;&nbsp; 55.6</td>
                        </tr>
                        <tr>
                            <td colspan='2'>
                                <b>
                                    DELHI TO MUMBAI via AHMEDABAD (1141.9 Kms.)
                                </b>
                                &nbsp;
                            </td>
                        </tr>
                        <tr>
                            <td>Delhi - Shahapura</td>
                            <td>&nbsp; 198.4</td>
                        </tr>
                        <tr>
                            <td>Shahapura - Jaipur</td>
                            <td>&nbsp;&nbsp;&nbsp; 55.2</td>
                        </tr>
                        <tr>
                            <td>Jaipur - Ajmer</td>
                            <td>&nbsp; 131.2</td>
                        </tr>
                        <tr>
                            <td>Ajmer - Beawar</td>
                            <td>&nbsp;&nbsp;&nbsp; 53.6</td>
                        </tr>
                        <tr>
                            <td>Beawar - Todgarh - Dewair</td>
                            <td>&nbsp; 107.6</td>
                        </tr>
                        <tr>
                            <td>Dewair - Nathdwara - Udaipur</td>
                            <td>&nbsp; 118.4</td>
                        </tr>
                        <tr>
                            <td>Udaipur - Shamlaji - Hajipur</td>
                            <td>&nbsp; 178.4</td>
                        </tr>
                        <tr>
                            <td>Hajipur - Ahmedabad</td>
                            <td>&nbsp;&nbsp;&nbsp; 73.2</td>
                        </tr>
                        <tr>
                            <td>Ahmedabad - Kaira</td>
                            <td>&nbsp;&nbsp;&nbsp; 38.6</td>
                        </tr>
                        <tr>
                            <td>Kaira - Baroda</td>
                            <td>&nbsp;&nbsp;&nbsp; 76.0</td>
                        </tr>
                        <tr>
                            <td>Baroda - Broach - Ankleshwar - Kadodra</td>
                            <td>&nbsp; 136.0</td>
                        </tr>
                        <tr>
                            <td>Kadodra - Pardi</td>
                            <td>&nbsp;&nbsp;&nbsp; 87.4</td>
                        </tr>
                        <tr>
                            <td>Pardi - Talasari - Shirsad</td>
                            <td>&nbsp; 126.4</td>
                        </tr>
                        <tr>
                            <td>Shirsad - Bassein Bridge - Mahim</td>
                            <td>&nbsp;&nbsp;&nbsp; 46.8</td>
                        </tr>
                        <tr>
                            <td>Mahim - Mumbai</td>
                            <td>&nbsp;&nbsp;&nbsp; 14.6</td>
                        </tr>
                        <tr>
                            <td colspan='2'>
                                <b>CHENNAI TO DELHI (2124.7 Kms.)</b> &nbsp;
                            </td>
                        </tr>
                        <tr>
                            <td>Chennai - Nellore</td>
                            <td>&nbsp; 127.8</td>
                        </tr>
                        <tr>
                            <td>Nellore - Ongole</td>
                            <td>&nbsp; 118.4</td>
                        </tr>
                        <tr>
                            <td>Ongole - Nagarjunsagar Dam</td>
                            <td>&nbsp; 180.9</td>
                        </tr>
                        <tr>
                            <td>Nagarjunsagar Dam - Hyderabad</td>
                            <td>&nbsp; 147.8</td>
                        </tr>
                        <tr>
                            <td>Hyderabad - Kamareddi</td>
                            <td>&nbsp; 114.0</td>
                        </tr>
                        <tr>
                            <td>Kamareddi - Adilabad - Pandharkawada</td>
                            <td>&nbsp; 222.8</td>
                        </tr>
                        <tr>
                            <td>Pandharkawada - Hingahat - Nagpur</td>
                            <td>&nbsp; 150.2</td>
                        </tr>
                        <tr>
                            <td>Nagpur - Seoni - Lakhandon</td>
                            <td>&nbsp; 187.2</td>
                        </tr>
                        <tr>
                            <td>Lakhandon - Narsinghpur</td>
                            <td>&nbsp;&nbsp;&nbsp; 68.4</td>
                        </tr>
                        <tr>
                            <td>Narsinghpur - Saugor</td>
                            <td>&nbsp; 135.4</td>
                        </tr>
                        <tr>
                            <td>Saugor - Jhansi</td>
                            <td>&nbsp; 199.2</td>
                        </tr>
                        <tr>
                            <td>Jhansi - Gwalior</td>
                            <td>&nbsp; 100.9</td>
                        </tr>
                        <tr>
                            <td>Gwalior - Agra</td>
                            <td>&nbsp; 116.8</td>
                        </tr>
                        <tr>
                            <td>Agra - Delhi</td>
                            <td>&nbsp; 210.0</td>
                        </tr>
                        <tr>
                            <td colspan='2'>
                                <b>
                                    MUMBAI TO CHENNAI via HYDERABAD (1329.1
                                    Kms.)
                                </b>
                                &nbsp;
                            </td>
                        </tr>
                        <tr>
                            <td>Mumbai - Thane Creek Bridge - Panvel</td>
                            <td>&nbsp;&nbsp;&nbsp; 50.8</td>
                        </tr>
                        <tr>
                            <td>Panvel - Khopali - Pune</td>
                            <td>&nbsp; 112.0</td>
                        </tr>
                        <tr>
                            <td>Pune - Ravangaon</td>
                            <td>&nbsp;&nbsp;&nbsp; 84.8</td>
                        </tr>
                        <tr>
                            <td>Ravangaon - Shethpal</td>
                            <td>&nbsp;&nbsp;&nbsp; 99.2</td>
                        </tr>
                        <tr>
                            <td>Shethapal - Mohol - Sholapur - Omarga</td>
                            <td>&nbsp; 142.4</td>
                        </tr>
                        <tr>
                            <td>Omarga - Zahidabad</td>
                            <td>&nbsp; 110.0</td>
                        </tr>
                        <tr>
                            <td>Zahidabad - Hyderabad</td>
                            <td>&nbsp; 110.0</td>
                        </tr>
                        <tr>
                            <td>Hyderabad - Nagarjunsagar Dam</td>
                            <td>&nbsp; 147.2</td>
                        </tr>
                        <tr>
                            <td>Nagarjunsagar Dam - Ongole</td>
                            <td>&nbsp; 180.9</td>
                        </tr>
                        <tr>
                            <td>Ongole - Nellore</td>
                            <td>&nbsp; 118.4</td>
                        </tr>
                        <tr>
                            <td>Nellore - Nayundupeta - Chennai</td>
                            <td>&nbsp; 172.8</td>
                        </tr>
                        <tr>
                            <td colspan='2'>
                                <b>
                                    MUMBAI TO CHENNAI via BANGALORE (1328.6
                                    Kms.)
                                </b>
                                &nbsp;
                            </td>
                        </tr>
                        <tr>
                            <td>Mumbai - Thane Greek Bridge - Panvel</td>
                            <td>&nbsp;&nbsp;&nbsp; 50.8</td>
                        </tr>
                        <tr>
                            <td>Panvel - Khopali - Pune</td>
                            <td>&nbsp; 112.0</td>
                        </tr>
                        <tr>
                            <td>Pune - Surul</td>
                            <td>&nbsp;&nbsp;&nbsp; 76.8</td>
                        </tr>
                        <tr>
                            <td>Surul - Satara - Kolhapur</td>
                            <td>&nbsp; 155.6</td>
                        </tr>
                        <tr>
                            <td>Kolhapur - Belgaum</td>
                            <td>&nbsp; 103.2</td>
                        </tr>
                        <tr>
                            <td>Belgaum - Kittur - Dharwar</td>
                            <td>&nbsp;&nbsp;&nbsp; 74.4</td>
                        </tr>
                        <tr>
                            <td>Dharwar - Harihar</td>
                            <td>&nbsp; 147.2</td>
                        </tr>
                        <tr>
                            <td>Harihar - Bangalore</td>
                            <td>&nbsp; 278.4</td>
                        </tr>
                        <tr>
                            <td>Bangalore - Ranipet</td>
                            <td>&nbsp; 218.2</td>
                        </tr>
                        <tr>
                            <td>Ranipet - Chennai</td>
                            <td>&nbsp; 112.0</td>
                        </tr>
                        <tr>
                            <td colspan='2'></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </SimplePage>
    )
}

export default RoadRoutes
